import { array, number, object, string } from "yup";
import { useBankingValidationSchema } from "../shared";
import { FormField } from "./types";
import { BooleanSwitchValue } from "consts/general";

const useValidationSchema = () =>
    useBankingValidationSchema()
        .concat(
            object().shape({
                [FormField.Options]: object()
                    .nullable()
                    .label('Options'),

                [FormField.Iso2]: array()
                    .of(string())
                    .min(1)
                    .nullable()
                    .label('Country ISO'),

                [FormField.Flow]: object()
                    .nullable()
                    .label('Flow'),

                [FormField.IsEnabled]: number()
                    .oneOf([BooleanSwitchValue.Off, BooleanSwitchValue.On])
                    .label('Is Enabled'),

                [FormField.Obs]: string()
                    .optional()
                    .label('Obs'),

                [FormField.ShouldCreditOnRedirect]: number()
                    .oneOf([BooleanSwitchValue.Off, BooleanSwitchValue.On])
                    .label('Should Credit Redirect'),
            })
        );

export default useValidationSchema;
